import { render } from "./StretchedLink.vue?vue&type=template&id=c229b916"
import script from "./StretchedLink.vue?vue&type=script&lang=js"
export * from "./StretchedLink.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/mdbvue/Utilities/StretchedLink.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c229b916"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c229b916', __exports__)) {
    api.reload('c229b916', __exports__)
  }
  
  module.hot.accept("./StretchedLink.vue?vue&type=template&id=c229b916", () => {
    api.rerender('c229b916', render)
  })

}


export default __exports__